import Component from '@glimmer/component';

import CommonProgressBarComponent from 'webapp/components/common/progress-bar';
import CommonSkeletonBarLoaderComponent from 'webapp/components/common/skeleton-bar-loader';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import GoalsStatusComponent from 'webapp/components/goals/status/index';

import type { Goal, GoalData } from 'webapp/models-custom';

export interface Args {
	model: Goal;
	goalData: GoalData;
	size: 'large' | 'small';
}

export default class GoalProgressComponent extends Component<Args> {
	get model() {
		return this.args.model;
	}

	get goalData() {
		return this.args.goalData;
	}

	get showNoDataAvailable() {
		return this.goalData.isCompareEmpty;
	}

	get isExpectedValueHidden() {
		return (
			this.model.isMainMetricPercentage ||
			this.model.isAboveOrBelowCondition ||
			this.model.isMetricCondition
		);
	}
	<template>
		<div class="goal-progress-ct">

			<div class="upper">
				{{#if this.goalData.isLoadingData}}
					<CommonSkeletonBarLoaderComponent @type="progress" />
				{{else}}
					<div class="progress-type {{if @model.isManualGoal 'empty'}}">
						{{#unless @model.isManualGoal}}
							<CommonUiIconComponent @name="BoltFill" @size="sm" />
						{{/unless}}
					</div>

					<CommonProgressBarComponent
						@percentage={{this.goalData.comparePoint.change}}
						@target={{this.goalData.expectedPercent}}
						@expectedTarget={{this.goalData.expectedValueStr}}
						@size={{@size}}
					/>

					{{#if this.goalData.comparePoint.changeStr}}
						<div class="perc">
							<span class="indicator {{this.goalData.currentProgressClass}}">
								{{this.goalData.comparePoint.changeStr}}
							</span>
						</div>
					{{/if}}
				{{/if}}
			</div>

			<div class="lower">
				<div class="values {{if this.goalData.isLoadingData 'loading'}}">
					<div class="current">
						{{#unless this.model.isManualGoal}}
							<CommonUiIconComponent @name="BoltFill" @size="sm" />
						{{/unless}}
						{{this.goalData.currentValueStr}}
					</div>
					{{#if this.goalData.isLoadingData}}
						<CommonSkeletonBarLoaderComponent @type="value-1" />
					{{else}}
						{{#if this.goalData.comparePoint.valueStr}}
							<div class="target">
								{{#if this.model.successConditionIcon}}
									<CommonUiIconComponent
										@name={{this.model.successConditionIcon}}
										@size="sm"
									/>
								{{/if}}
								<div class="target-value">
									{{this.goalData.comparePoint.valueStr}}
								</div>
							</div>
						{{/if}}
					{{/if}}
				</div>

				{{#if this.goalData.isLoadingData}}
					<CommonSkeletonBarLoaderComponent @type="value-2" />
				{{else}}
					<div class="perc {{if this.showNoDataAvailable 'empty'}}">
						{{#if this.showNoDataAvailable}}
							No data available
						{{else}}
							<span class="indicator {{this.goalData.currentProgressClass}}">
								{{this.goalData.comparePoint.changeStr}}
							</span>
						{{/if}}
					</div>
				{{/if}}

				{{#unless this.goalData.isCompareEmpty}}
					<GoalsStatusComponent
						@status={{this.goalData.status}}
						@timeLeftText={{this.goalData.timeLeftText}}
					/>
				{{/unless}}
			</div>
		</div>
	</template>
}
